import { RadioGroup as RadixRadioGroup } from 'radix-ui';
import { Typography, TypographyVariants } from '../Typography';
import { PropsWithChildren, useId } from 'react';
import { twMerge } from 'tailwind-merge';

export interface RadioGroupItemProps extends RadixRadioGroup.RadioGroupItemProps {
  containerClassName?: string;
  labelVariant?: TypographyVariants;
  labelClassname?: string;
  label?: string;
}

export const RadioGroupItem = ({
  children,
  containerClassName,
  className,
  labelVariant = 'caption020',
  labelClassname,
  label,
  id,
  ...otherProps
}: PropsWithChildren<RadioGroupItemProps>) => {
  const generatedId = useId();
  const itemId = id ?? generatedId;

  return (
    <RadixRadioGroup.Item
      className={twMerge(
        'flex appearance-none items-center gap-2.5 border-0 bg-transparent p-0 text-left font-[inherit] text-inherit outline-none cursor-pointer disabled:cursor-not-allowed disabled:opacity-60 focus-visible:ring-2 focus-visible:ring-[--inputfield-input-border-active] focus-visible:ring-offset-2',
        containerClassName
      )}
      id={itemId}
      {...otherProps}
    >
      <span
        aria-hidden="true"
        className={twMerge(
          'pointer-events-none flex size-[20px] shrink-0 items-center justify-center rounded-full border-2 border-[--radio-formation-radio-default] bg-white p-0.5',
          className
        )}
      >
        <RadixRadioGroup.Indicator
          className={
            'relative flex size-full items-center justify-center after:block after:size-[11px] after:rounded-full after:bg-[--radio-formation-radio-default]'
          }
        />
      </span>
      {label ? (
        <Typography variant={labelVariant} className={labelClassname} as="span">
          {label}
        </Typography>
      ) : null}
      {children}
    </RadixRadioGroup.Item>
  );
};
